import axios from "axios";
import config from "../../config";
import axiosInstance from "../axiosInstance";

// NOTA: Con el nuevo proxy InfoAuto, la autenticación se maneja en el backend
// El frontend ya no necesita autenticarse directamente con InfoAuto
// Estas funciones ahora son stubs que simulan autenticación exitosa

const info_auto_login = async () => {
	try {
		// Simular autenticación exitosa ya que el proxy maneja la auth
		// En el futuro, esto podría llamar a un endpoint de auth de nuestro backend
		console.log("InfoAuto auth handled by proxy - simulating successful login");
		
		// Generar un token dummy para mantener compatibilidad
		const dummyToken = "proxy-handled-auth-" + Date.now();
		localStorage.setItem("info_auto_access_token", dummyToken);
		localStorage.setItem("info_auto_refresh_token", dummyToken);

		return true;
	} catch (error) {
		console.error("Login failed:", error.response?.data || error.message);
		return false;
	}
};

const info_auto_refreshAccessToken = async () => {
	try {
		// Simular refresh exitoso ya que el proxy maneja la auth
		console.log("InfoAuto token refresh handled by proxy");
		
		// Generar un nuevo token dummy
		const dummyToken = "proxy-handled-refresh-" + Date.now();
		localStorage.setItem("info_auto_access_token", dummyToken);
		
		return dummyToken;
	} catch (error) {
		console.warn("Refresh token failed, retrying full login...");
		const loginSuccess = await info_auto_login();
		if (loginSuccess) {
			return localStorage.getItem("info_auto_access_token");
		} else {
			console.error("Failed to re-login");
			return null;
		}
	}
};

export { info_auto_login, info_auto_refreshAccessToken };
